<template>
    <div class="card mb-0 shadow">
        <div class="card-body">
            <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                    <div class="row">
                        <div class="col-12">
                            <h4 class="font-weight-bold">Objetivos / Metas</h4>
                        </div>
                    </div>
                    <div class="row px-3">
                        <ul class="nav nav-pills flex-column col-md-3 px-0">
                            <li class="nav-item mb-2">
                                <a
                                    @click="aba = 'documental'"
                                    :class="aba == 'documental' ? 'active' : ''"
                                    class="list-group-item nav-link list-group-item-action"
                                    >Situação Documental</a
                                >
                            </li>
                            <li class="nav-item mb-2">
                                <a
                                    class="list-group-item nav-link list-group-item-action"
                                    @click="aba = 'processual'"
                                    :class="aba == 'processual' ? 'active' : ''"
                                    >Situação Processual</a
                                >
                            </li>
                            <li class="nav-item mb-2">
                                <a
                                    class="list-group-item nav-link list-group-item-action"
                                    @click="aba = 'saude'"
                                    :class="aba == 'saude' ? 'active' : ''"
                                    >Saúde</a
                                >
                            </li>
                            <li class="nav-item mb-2">
                                <a
                                    class="list-group-item nav-link list-group-item-action"
                                    @click="aba = 'educacao'"
                                    :class="aba == 'educacao' ? 'active' : ''"
                                    >Educação</a
                                >
                            </li>
                            <li class="nav-item mb-2">
                                <a
                                    class="list-group-item nav-link list-group-item-action"
                                    @click="aba = 'profissionalizacao'"
                                    :class="
                                        aba == 'profissionalizacao'
                                            ? 'active'
                                            : ''
                                    "
                                    >Profissionalização</a
                                >
                            </li>
                            <li class="nav-item mb-2">
                                <a
                                    class="list-group-item nav-link list-group-item-action"
                                    @click="aba = 'arte'"
                                    :class="aba == 'arte' ? 'active' : ''"
                                    >Arte, Cultura, Esporte E Lazer</a
                                >
                            </li>
                            <li class="nav-item mb-2">
                                <a
                                    class="list-group-item nav-link list-group-item-action"
                                    @click="aba = 'aspecto'"
                                    :class="aba == 'aspecto' ? 'active' : ''"
                                    >Aspectos Sociofamiliares</a
                                >
                            </li>
                            <li class="nav-item mb-2">
                                <a
                                    class="list-group-item nav-link list-group-item-action"
                                    @click="aba = 'condicao'"
                                    :class="aba == 'condicao' ? 'active' : ''"
                                    >Condições Socioeconômicas
                                </a>
                            </li>
                            <li class="nav-item mb-2">
                                <a
                                    class="list-group-item nav-link list-group-item-action"
                                    @click="aba = 'vulnerabilidade'"
                                    :class="
                                        aba == 'vulnerabilidade' ? 'active' : ''
                                    "
                                    >Vulnerabilidade sociofamiliares</a
                                >
                            </li>
                            <li class="nav-item mb-2">
                                <a
                                    class="list-group-item nav-link list-group-item-action"
                                    @click="aba = 'preparacao'"
                                    :class="aba == 'preparacao' ? 'active' : ''"
                                    >Preparação para desligamento</a
                                >
                            </li>
                        </ul>
                        <div class="col-md-9">
                            <div v-show="aba == 'documental'">
                                <div class="row">
                                    <h4 class="px-3">Situação Documental</h4>
                                    <form-calendar
                                        label="Prazo"
                                        v-model="metas.documental_prazo"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="
                                            metas.documental_situacao_atual
                                        "
                                        label="Situação Atual"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metas.documental_meta"
                                        label="Objetivo/Meta"
                                    />
                                </div>
                            </div>
                            <div v-show="aba == 'processual'">
                                <div class="row">
                                    <h4 class="px-3">Situação Processual</h4>
                                    <form-calendar
                                        label="Prazo"
                                        v-model="metas.processual_prazo"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="
                                            metas.processual_situacao_atual
                                        "
                                        label="Situação Atual"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metas.processual_meta"
                                        label="Objetivo/Meta"
                                    />
                                </div>
                            </div>
                            <div v-show="aba == 'saude'">
                                <div class="row">
                                    <h4 class="px-3">Saúde</h4>
                                    <form-calendar
                                        label="Prazo"
                                        v-model="metas.saude_prazo"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metas.saude_situacao_atual"
                                        label="Situação Atual"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metas.saude_meta"
                                        label="Objetivo/Meta"
                                    />
                                </div>
                            </div>
                            <div v-show="aba == 'educacao'">
                                <div class="row">
                                    <h4 class="px-3">Educação</h4>
                                    <form-calendar
                                        label="Prazo"
                                        v-model="metas.educacao_prazo"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metas.educacao_situacao_atual"
                                        label="Situação Atual"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metas.educacao_meta"
                                        label="Objetivo/Meta"
                                    />
                                </div>
                            </div>
                            <div v-show="aba == 'profissionalizacao'">
                                <div class="row">
                                    <h4 class="px-3">Profissionalização</h4>
                                    <form-calendar
                                        label="Prazo"
                                        v-model="metas.profissionalizacao_prazo"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="
                                            metas.profissionalizacao_situacao_atual
                                        "
                                        label="Situação Atual"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metas.profissionalizacao_meta"
                                        label="Objetivo/Meta"
                                    />
                                </div>
                            </div>
                            <div v-show="aba == 'arte'">
                                <div class="row">
                                    <h4 class="px-3">
                                        Arte, Cultura, Esporte E Lazer
                                    </h4>
                                    <form-calendar
                                        label="Prazo"
                                        v-model="metas.arte_prazo"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metas.arte_situacao_atual"
                                        label="Situação Atual"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metas.arte_meta"
                                        label="Objetivo/Meta"
                                    />
                                </div>
                            </div>
                            <div v-show="aba == 'aspecto'">
                                <div class="row">
                                    <h4 class="px-3">
                                        Aspectos Sociofamiliares
                                    </h4>
                                    <form-calendar
                                        label="Prazo"
                                        v-model="metas.aspecto_prazo"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metas.aspecto_situacao_atual"
                                        label="Situação Atual"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metas.aspecto_meta"
                                        label="Objetivo/Meta"
                                    />
                                </div>
                            </div>
                            <div v-show="aba == 'condicao'">
                                <div class="row">
                                    <h4 class="px-3">
                                        Condições Socioeconômicas
                                    </h4>
                                    <form-calendar
                                        label="Prazo"
                                        v-model="metas.condicao_prazo"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metas.condicao_situacao_atual"
                                        label="Situação Atual"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metas.condicao_meta"
                                        label="Objetivo/Meta"
                                    />
                                </div>
                            </div>
                            <div v-show="aba == 'vulnerabilidade'">
                                <div class="row">
                                    <h4 class="px-3">
                                        Vulnerabilidade sociofamiliares
                                    </h4>
                                    <form-calendar
                                        label="Prazo"
                                        v-model="metas.vulnerabildiade_prazo"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="
                                            metas.vulnerabildiade_situacao_atual
                                        "
                                        label="Situação Atual"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metas.vulnerabildiade_meta"
                                        label="Objetivo/Meta"
                                    />
                                </div>
                            </div>
                            <div v-show="aba == 'preparacao'">
                                <div class="row">
                                    <h4 class="px-3">
                                        Preparação para desligamento
                                    </h4>
                                    <form-calendar
                                        label="Prazo"
                                        v-model="metas.desligamento_prazo"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="
                                            metas.desligamento_situacao_atual
                                        "
                                        label="Situação Atual"
                                    />
                                    <form-textarea-editor
                                        class="mt-3"
                                        v-model="metas.desligamento_meta"
                                        label="Objetivo/Meta"
                                    />
                                </div>
                            </div>
                            <div class="row px-2 d-flex justify-content-end">
                                <button
                                    class="btn btn-success btn-submit"
                                    data-style="zoom-in"
                                    @click="submit"
                                    type="submit"
                                >
                                    <i class="mdi mdi-content-save" />
                                    {{ $t("Salvar") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["medida"],
    data() {
        return {
            metas: {
                documental_prazo: "",
                documental_situacao_atual: "",
                documental_meta: "",
                processual_prazo: "",
                processual_situacao_atual: "",
                processual_meta: "",
                saude_prazo: "",
                saude_situacao_atual: "",
                saude_meta: "",
                educacao_prazo: "",
                educacao_situacao_atual: "",
                educacao_meta: "",
                profissionalizacao_prazo: "",
                profissionalizacao_situacao_atual: "",
                profissionalizacao_meta: "",
                arte_prazo: "",
                arte_situacao_atual: "",
                arte_meta: "",
                aspecto_prazo: "",
                aspecto_situacao_atual: "",
                aspecto_meta: "",
                condicao_prazo: "",
                condicao_situacao_atual: "",
                condicao_meta: "",
                vulnerabildiade_prazo: "",
                vulnerabildiade_situacao_atual: "",
                vulnerabildiade_meta: "",
                desligamento_prazo: "",
                desligamento_situacao_atual: "",
                desligamento_meta: "",
            },
            aba: "documental",
        };
    },
    mounted() {
        if (this.medida.metas) {
            this.metas = this.medida.metas;
        }
    },
    watch: {
        medida(n, o) {
            this.metas = this.medida.metas;
        },
    },
    methods: {
        submit() {
            // if (this.metas.processual_prazo != "") {
            // 	this.metas.processual_prazo = moment(this.metas.processual_prazo).format(
            // 		"YYYY-MM-DD"
            // 	);
            // }
            // if (this.metas.documental_prazo != "") {
            // 	this.metas.documental_prazo = moment(this.metas.documental_prazo).format(
            // 		"YYYY-MM-DD"
            // 	);
            // }
            // if (this.metas.saude_prazo != "") {
            // 	this.metas.saude_prazo = moment(this.metas.saude_prazo).format("YYYY-MM-DD");
            // }
            // if (this.metas.profissionalizacao_prazo != "") {
            // 	this.metas.profissionalizacao_prazo = moment(
            // 		this.metas.profissionalizacao_prazo
            // 	).format("YYYY-MM-DD");
            // }
            // if (this.metas.educacao_prazo != "") {
            // 	this.metas.educacao_prazo = moment(this.metas.educacao_prazo).format(
            // 		"YYYY-MM-DD"
            // 	);
            // }
            // if (this.metas.educacao_prazo != "") {
            // 	this.metas.educacao_prazo = moment(this.metas.educacao_prazo).format(
            // 		"YYYY-MM-DD"
            // 	);
            // }
            // if (this.metas.arte_prazo != "") {
            // 	this.metas.arte_prazo = moment(this.metas.arte_prazo).format("YYYY-MM-DD");
            // }
            // if (this.metas.aspecto_prazo != "") {
            // 	this.metas.aspecto_prazo = moment(this.metas.aspecto_prazo).format(
            // 		"YYYY-MM-DD"
            // 	);
            // }
            // if (this.metas.condicao_prazo != "") {
            // 	this.metas.condicao_prazo = moment(this.metas.condicao_prazo).format(
            // 		"YYYY-MM-DD"
            // 	);
            // }
            // if (this.metas.vulnerabildiade_prazo != "") {
            // 	this.metas.vulnerabildiade_prazo = moment(
            // 		this.metas.vulnerabildiade_prazo
            // 	).format("YYYY-MM-DD");
            // }
            // if (this.metas.desligamento_prazo != "") {
            // 	this.metas.desligamento_prazo = moment(this.metas.desligamento_prazo).format(
            // 		"YYYY-MM-DD"
            // 	);
            // }
            this.medida.metas = this.metas;
            this.$emit("submit");
        },
    },
};
</script>
<style scoped>
li.nav-item mb-2 a {
    cursor: pointer !important;
}
</style>
